var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.getStyle)},[_c('div',{style:(_vm.getStyle)},[_vm._v(_vm._s(_vm.renderDiff))]),(_vm.showBaseprice)?_c('div',{class:_vm.classBaseprice,style:(_vm.getStyle)},[_vm._v("Soit "+_vm._s(_vm.newPrice)+" "+_vm._s(_vm.$t(_vm.currencycode+'-symbol'))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }